import TransactionsForm from './TransactionsForm.js';

export default TransactionsForm;
